import * as Diagram from "../../../../components/diagram";
import { generateSerialArray } from "../../../common";
import moment from "moment";

export const ElderlyHealthVisitMonthly = {
  label: "長者健康關懷訪視月報表",
  key: "ElderlyHealthVisitMonthly",
  path: "ElderlyHealth/ElderlyHealthVisitMonthly",
  api: "TCS_V_ElderlyHealthCareVisitMonthlyReport",
  render: (options) => (
    <Diagram.ElderlyHealth.ElderlyHealthVisitMonthly {...options} />
  ),
  isRaw: true,
  isPage: true,
  page: null,
  isGroup: true,
  groupColumns: [
    {
      key: "RegionName",
      field: "RegionName",
      header: "鄉別",
    },
    {
      key: "VillageName",
      field: "VillageName",
      header: "村別",
    },
  ],
  // filterMainKey: "ElderlyHealthSame",
  // filterColumns: [
  //   {
  //     key: "noback_year",
  //     label: "年份",
  //     type: "singleDropdown",
  //     options: generateSerialArray(2023, Number(moment().format("YYYY"))).map(
  //       (item) => ({ label: item, value: item })
  //     ),
  //   },
  // ],
  dateRangeColumns: [{ label: "填寫日期", key: "填寫日期" }],
  columns: [
    {
      key: "inVillage",
      field: "inVillage_format",
      header: "65歲以上\n在籍人數",
    },
    {
      key: "visitCount",
      field: "visitCount_format",
      header: "已完訪人數",
    },
    {
      key: "visit_percent",
      field: "visit_percent",
      header: "完成率",
    },
    {
      key: "unVisitCount",
      field: "unVisitCount_format",
      header: "待訪人數",
    },
    {
      key: "unVisit_percent",
      field: "unVisit_percent",
      header: "待訪比率",
    },
    {
      key: "inAgency",
      field: "inAgency_format",
      header: "居住本縣機構人數",
    },
    {
      key: "dead",
      field: "dead_format",
      header: "死亡",
    },
    {
      key: "level",
      field: "level_format",
      header: "已訪人數列管等級",
      // isControl: true,
      // isSum: true,
      child: [
        {
          key: "level1",
          field: "level1_format",
          header: "健康",
          child: [
            {
              key: "level1",
              field: "level1_format",
              header: "人數",
            },
            {
              key: "level1_rate",
              field: "level1_rate",
              header: "占比",
            },
          ],
        },
        {
          key: "level2",
          field: "level2_format",
          header: "衰弱",
          child: [
            {
              key: "level2",
              field: "level2_format",
              header: "人數",
            },
            {
              key: "level2_rate",
              field: "level2_rate",
              header: "占比",
            },
          ],
        },
        {
          key: "level3",
          field: "level3_format",
          header: "失能",
          child: [
            {
              key: "level3",
              field: "level3_format",
              header: "人數",
            },
            {
              key: "level3_rate",
              field: "level3_rate",
              header: "占比",
            },
          ],
        },
      ],
    },
  ],
};
